import { p, param } from "framer-motion/client";
import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";
import CryptoJS from "crypto-js";
const ENCRYPTION_KEY = import.meta.env.VITE_AES_KEY;

export const fetchRaSummaryReport = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.JOBS.GET_ALL}`,
        params: {
            coll: params.coll,
            pg: params.pg || 1,
            lim: params.lim || 10,
            fil: JSON.stringify(params.fil),
            useAggregate: params.useAggregate,
            extret: params.extret,
            queryMode: params.queryMode
        },
    });
}

export const fetchRaDownloadSummaryReport = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.JOBS.GET_ALL}`,
        params: {
            coll: params.coll,
            pg: params.pg || 1,
            lim: params.lim || 10,
            fil: JSON.stringify(params.fil),
            useAggregate: params.useAggregate,
            ret: params.ret,
            extret: params.extret
        },
    });
}

export const fetchBdmSummaryReport = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.JOBS.GET_ALL}`,
        params: {
            coll: params.coll,
            pg: params.pg || 1,
            lim: params.lim || 10,
            fil: JSON.stringify(params.fil),
            ret: params.ret,
            extret: params.extret,
            ref: params.ref,
            incl: params.incl
        },
    });
}

export const fetchRecruiterSummaryReport = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.SUBMISSOINS.GET_ALL}`,
        params: {
            coll: params.coll,
            pg: params.pg || 1,
            lim: params.lim || 10,
            fil: JSON.stringify(params.fil),
            ret:params.ret,
            extret:params.extret,
            ref:params.ref,
            useAggregate:params.useAggregate,
            queryMode:params.queryMode
        },
    });
}

export const fetchRecruiterEmailDelivaryReport = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.EMAIL.GET_ALL}`,
        params: {
            coll: params.coll,
            pg: params.pg || 1,
            lim: params.lim || 10,
            fil: JSON.stringify(params.fil),
            useAggregate: params?.useAggregate,
            extret: params?.extret,
            ref: params?.ref,
            incl: params?.incl
        },
    });
}

export const fetchReports =  async (params) => {
    return await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.REPORTS.GET_ALL}`,
        params: {
            coll: params.coll,
            pg: params.pg || 1,
            lim: params.lim || 10,
            fil: JSON.stringify(params.fil),
        }
    });
}

export const fetchFavouriteReportsApi =  async (params) => {
    return await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.FAVOURITE_REPORTS.GET_ALL}`,
        params: {
            coll: params.coll,
            pg: params.pg || 1,
            lim: params.lim || 10,
            fil: JSON.stringify(params.fil),
        }
    });
}

export const addFavouriteReportApi =  async (params) => {
    return await axiosRequest({
        method: "POST",
        url: `${ENDPOINTS.FAVOURITE_REPORTS.ADD}`,
        data: {
            coll: "FavouriteReport",
            payload: params
        }
    });
}

export const deleteFavouriteReportApi =  async (params) => {
    return await axiosRequest({
        method: "DELETE",
        url: `${ENDPOINTS.FAVOURITE_REPORTS.DELETE}`,
        data: {
            coll: "FavouriteReport",
            uiid: params.uiid
        }
    });
}

export const aiCallSummaryReportApi = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.AICALLS.GET_ALL}`,
        params: {
            coll: params.coll,
            fil: JSON.stringify(params.fil),
            useAggregate: params.useAggregate,
            extret: params.extret,
            pg: params.pg,
            lim: params.lim,
        }
    });
};

export const creditUtilizationReportApi = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.JOB_BOARDS_CREDIT_HISTORY.GET_ALL}`,
        params: {
            coll: params.coll,
            fil: JSON.stringify(params.fil),
            useAggregate: params.useAggregate,
            pg: params.pg,
            lim: params.lim,
        }
    });
};

export const resumeMiningHistoryReportApi = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.RESUME_MINING_HISTORY.GET_ALL}`,
        params: {
            coll: params.coll,
            fil: JSON.stringify(params.fil),
            useAggregate: params.useAggregate,
            pg: params.pg,
            lim: params.lim,
        }
    });
};


export const fetchRecruiterEmailDelivaryReportNew = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.EMAIL.GET_ALL_CAMPAIGNS}`,
        params: {
            coll: params.coll,
            pg: params.pg || 1,
            lim: params.lim || 10,
            fil: JSON.stringify(params.fil),
            useAggregate: params?.useAggregate,
            extret: params?.extret,
            ref: params?.ref,
            incl: params?.incl,
            errorHandler: params?.errorHandler
        },
    });
}

export const fetchEmailReportDataApi = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.EMAIL.GET_ALL}`,
        params: {
            coll: params.coll,
            pg: params.pg || 1,
            lim: params.lim || 10,
            fil: JSON.stringify(params.fil),
            useAggregate: params?.useAggregate,
            ret : params?.ret,
            extret: params?.extret,
            ref: params?.ref,
            incl: params?.incl,
            errorHandler: params?.errorHandler
        },
    });
}